var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPersonalityQuizIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 15C29.5 23.0081 23.0081 29.5 15 29.5C6.99187 29.5 0.5 23.0081 0.5 15C0.5 6.99187 6.99187 0.5 15 0.5C23.0081 0.5 29.5 6.99187 29.5 15Z",
    fill: "white",
    stroke: "#9560E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.74766 22.6658C8.19539 22.6658 7.74768 22.2181 7.74768 21.6658C7.74768 21.5559 7.76581 21.4467 7.80132 21.3427C8.18459 20.2202 8.86597 19.3213 9.84545 18.6459C11.5924 17.4413 13.3469 17.3967 13.7726 15.5706C12.1714 14.8565 11.0296 12.9936 11.0296 10.8079C11.0296 8.00587 12.9061 5.73438 15.2208 5.73438C17.5355 5.73438 19.412 8.00587 19.412 10.8079C19.412 13.1342 18.1186 15.0948 16.3548 15.6935C16.8284 17.3993 18.5427 17.4687 20.2499 18.6459C21.2294 19.3213 21.9108 20.2202 22.2941 21.3427C22.3296 21.4467 22.3477 21.5559 22.3477 21.6658C22.3477 22.1836 21.9542 22.6095 21.45 22.6607L21.3477 22.6658H15.0952H15.0002H8.74766Z",
    stroke: "#9560E6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalityQuizIcon);
export default __webpack_public_path__ + "static/media/personalityQuiz_icon.b69b0b60f944f9559f6ea3872f595da7.svg";
export { ForwardRef as ReactComponent };